module.exports = __webpack_public_path__ + "img/visorExit.3201c946.svg";